import { darkElixirsEndpoints } from "./dark-elixirs.api"

export const {
  useGetUsersDarkElixirsQuery,
  useGetActivatedDarkElixirsQuery,
  useActivateDarkElixirMutation,
  endpoints: {
    getUsersDarkElixirs,
    getActivatedDarkElixirs,
    activateDarkElixir
  }
} = darkElixirsEndpoints
